/**
 * authHeaders — shared helper for module-host services.
 *
 * Reads the vibe-designer JWT from localStorage and returns the canonical
 * Authorization header. The localStorage key is the same one vibe-designer
 * uses (see vibe-designer/frontend/src/services/api.ts:88).
 *
 * Because briefing-room-module is bundled INTO vibe-designer via the
 * `@briefing-room-module` vite alias (M3a Option α — direct source import),
 * localStorage is the same origin and no postMessage bridge is needed.
 */
export const TOKEN_KEY = 'vibe_designer_token';

export function getBearerToken(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function getAuthHeaders(): Record<string, string> {
  const token = getBearerToken();
  return token === null ? {} : { Authorization: `Bearer ${token}` };
}
